import { ThemeProvider } from '@mui/material'
import { Route, Routes } from 'react-router-dom'
import './App.css'
import theme from './assets/theme/theme'
import { Footer } from './components/Footer/Footer'
import { Header } from './components/Header/Header'
import ScrollTop from './components/ScrollTop/ScrollTop'
import { Hiring } from './pages/360Hiring/Hiring'
import { AboutUs } from './pages/AboutUs/AboutUs'
import { AgentForm } from './pages/AgentForm/AgentForm'
import { CodeOfConduct } from './pages/CodeOfConduct/CodeOfConduct'
import { CodeOfConductPdf } from './pages/CodeOfConductPdf/CodeOfConductPdf'
import { Construction } from './pages/Construction/Construction'
import { CorporateResponsibility } from './pages/CorporateResponsibility/CorporateResponsibility'
import { CostReduction } from './pages/CostReduction/CostReduction'
import { DemandForm } from './pages/DemandForm/DemandForm'
import { EthicsCompliance } from './pages/EthicsCompliance/EthicsCompliance'
import { History } from './pages/History/History'
import { Hospitality } from './pages/Hospitality/Hospitality'
import { HrConsultancy } from './pages/HrConsultancy/HrConsultancy'
import { Individuals } from './pages/Individuals/Individuals'
import { Locations } from './pages/Locations/Locations'
import { Main } from './pages/Main/Main'
import { Manufacturing } from './pages/Manufacturing/Manufacturing'
import { Mission } from './pages/Mission/Mission'
import { Network } from './pages/Network/Network'
import { OurReferences } from './pages/OurReferences/OurReferences'
import { Purpose } from './pages/Purpose/Purpose'
import { Recruitment } from './pages/Recruitment/Recruitment'
import { RelationshipBased } from './pages/RelationshipBased/RelationshipBased'
import { Services } from './pages/Services/Services'
import { Solutions } from './pages/Solutions/Solutions'
import { StaffAccommodation } from './pages/StaffAccommodation/StaffAccommodation'
import { StaffingManagement } from './pages/StaffingManagement/StaffingManagement'
import { Vision } from './pages/Vision/Vision'
function App() {
	const ExternalRedirect = () => {
		window.location.href = 'http://portal.avrasyaconsulting.com'
		return null
	}

	return (
		<ThemeProvider theme={theme}>
			<div className='app-wrapper'>
				<Header />
				<Routes>
					<Route path={'/'} element={<Main />}></Route>
					<Route path={'/aboutUs'} element={<AboutUs />}></Route>
					<Route path={'/Mission'} element={<Mission />}></Route>
					<Route path={'/History'} element={<History />}></Route>
					<Route path={'/Purpose'} element={<Purpose />}></Route>
					<Route path={'/Vision'} element={<Vision />}></Route>
					<Route
						path={'/Ethics-Compliance'}
						element={<EthicsCompliance />}
					></Route>
					<Route
						path={'/Relationship-based'}
						element={<RelationshipBased />}
					></Route>
					<Route path={'/CodeOfConduct'} element={<CodeOfConduct />}></Route>
					<Route
						path={'/CorporateResponsibility'}
						element={<CorporateResponsibility />}
					></Route>
					<Route
						path={'/CodeOfConductPdf'}
						element={<CodeOfConductPdf />}
					></Route>
					<Route path={'/CostReduction'} element={<CostReduction />}></Route>
					<Route
						path={'/StaffAccommodation'}
						element={<StaffAccommodation />}
					></Route>
					<Route path={'/HrConsultancy'} element={<HrConsultancy />}></Route>
					<Route path={'/Services'} element={<Services />}></Route>
					<Route path={'/Recruitment'} element={<Recruitment />}></Route>
					<Route
						path={'/StaffingManagement'}
						element={<StaffingManagement />}
					></Route>
					<Route path={'/360Hiring'} element={<Hiring />}></Route>
					<Route path={'/OurReferences'} element={<OurReferences />}></Route>
					<Route path={'/Hospitality'} element={<Hospitality />}></Route>
					<Route path={'/Manufacturing'} element={<Manufacturing />}></Route>
					<Route path={'/Construction'} element={<Construction />}></Route>
					<Route path={'/Solutions'} element={<Solutions />}></Route>
					<Route path={'/DemandForm'} element={<DemandForm />}></Route>
					<Route path={'/Network'} element={<Network />}></Route>
					<Route path={'/AgentForm'} element={<AgentForm />}></Route>
					<Route path='/Portal' element={<ExternalRedirect />} />
					<Route path={'/Individuals'} element={<Individuals />}></Route>
					<Route path={'/Locations'} element={<Locations />}></Route>
				</Routes>

				<Footer />
				<ScrollTop />
			</div>
		</ThemeProvider>
	)
}

export default App
